module.exports = __webpack_public_path__ + "static/img/home_logo.05686efb.png";